import React, { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import classNames from 'classnames';
import HtmlContainer from './html_container';

interface Message {
  subject?: string;
  content?: string;
  reply_body?: string;
}

interface TruncatedMessageProps {
  data: Message;
  maxHeight?: number;
}

const TruncatedMessage = ({ data, maxHeight = 100 }: TruncatedMessageProps) => {
  const [expanded, toggle] = useState(false);
  const [shouldBeTrimmed, setShouldBeTrimmed] = useState(false);
  const contentEl = useRef(null);

  const message = useMemo(() => {
    if (!data) return null;
    return data.content || data.reply_body;
  }, [data]);

  const checkHeight = useCallback(() => {
    if (contentEl.current) {
      setShouldBeTrimmed(contentEl.current.clientHeight > maxHeight);
    }
  }, [maxHeight]);

  useEffect(() => {
    window.addEventListener('resize', checkHeight);
    return () => window.removeEventListener('resize', checkHeight);
  }, [checkHeight]);

  useLayoutEffect(() => {
    checkHeight();
  }, [maxHeight, checkHeight]);

  return (
    <div className="html-message">
      <strong className="subject" ng-if="data.subject">
        <HtmlContainer html={data.subject}></HtmlContainer>
      </strong>
      <div
        className={classNames('ta-trimmed-content', {
          'reply-message': data?.reply_body?.length,
          'ta-trimmed-content--with-toggle': shouldBeTrimmed,
        })}
        style={{ maxHeight: shouldBeTrimmed && !expanded ? maxHeight : null }}
      >
        <div ref={contentEl} className="ta-full-content">
          <HtmlContainer html={message}></HtmlContainer>
        </div>
        {shouldBeTrimmed && (
          <a className="show-content-action" onClick={() => toggle(!expanded)}>
            show {expanded ? 'less' : 'more'}
          </a>
        )}
      </div>
    </div>
  );
};

export default TruncatedMessage;
